import { h } from 'preact'

export function BlogCard({ blog }) {
  const articleImage = blog.image_alt || blog.image

  return (
    <a href={blog.url} className="group/blog-card flex flex-col gap-1.5" aria-label={`Read more about ${blog.title}`}>
      <div className="w-full aspect-1/1 bg-neutral-medium overflow-hidden children:size-full children:object-cover children:group-hover/blog-card:scale-[1.025] children:transition-all">
        {articleImage?.src && (
          <img
            src={articleImage.src}
            alt={articleImage.alt || blog.title}
            className="size-full object-cover group-hover/blog-card:scale-[1.025] transition-all"
            loading="lazy"
            width={articleImage.width}
            height={articleImage.height}
          />
        )}
      </div>

      <div className="flex flex-col gap-y-0.75 px-0.25">
        <h4 className="h4">{blog.title}</h4>
        {blog.excerpt && (
          <div className="w-fit richtext paragraph-s">
            {blog.excerpt}
          </div>
        )}
        <div className="btn btn-primary btn-s btn-text w-fit group-hover/blog-card:opacity-50 !capitalize">
          Read More
        </div>
      </div>
    </a>
  )
}
